import { useEffect, useState } from "react";
import FormYearMonth from '../components/form-year-month';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { JobExperiencesModel, SignupModelHelper } from "../data/SignupModel";
import { months } from '../data/months';
import { AmplitudeService } from '../services/AmplitudeService';

export default function ExperienciaSaida(props: any) {

  const [interactions, setInteractions] = useState<InteractionModel[]>([]);
  const [experience, setExperience] = useState<JobExperiencesModel>(SignupModelHelper.getOngoingExperience());

  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });

    // TagManager.dataLayer(dataLayerHelper.pagina('saida', 'experiencia'));
    AmplitudeService.track('Experience End Date Screen')

    const signup = SignupModelHelper.get();
    setExperience(SignupModelHelper.getOngoingExperience());
    if (signup) {
    } else {
      document.location = './';
    }
  }, [])

  function setLeaveYear(yearMonth: string) {
    let chat: any = [];
    const maxYear = new Date().getFullYear();
    const dateFinish: Date = new Date(yearMonth + "-01T12:00");
    const today = new Date();
    today.setHours(12);

    const [year] = yearMonth.split('-');

    chat = [...interactions, {
      text: `${months[dateFinish.getMonth()]} de ${dateFinish.getFullYear()}`,
      author: InteractionAuthor.CLIENTE
    }];
    setInteractions(chat);

    if (isNaN(+year) || +year < 1900) {

      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Informe um ano entre 1900 e ${maxYear}`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)
    } else if (new Date(experience?.start).getFullYear() > +year) {

      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `O ano de saída deve ser o mesmo ou posterior ao de entrada.`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    } else if (dateFinish > today) {
      const nextMonth = new Date();
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `Selecione um mês anterior a ${months[nextMonth.getMonth()]} de ${nextMonth.getFullYear()}.`
        }]);
        
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)
    } else if (dateFinish < new Date(experience?.start)) {

      setTimeout(() => {
        setInteractions([...chat, {
          author: InteractionAuthor.AMARELINHO,
          text: `O mês de saída deve ser o mesmo ou posterior ao de entrada.`
        }]);
        setTimeout(() => {
          let chat = document.getElementsByClassName('chat')[0];
          chat.scrollTo(0, chat.scrollHeight);
        }, 500);
      }, 1000)

    } else {
      SignupModelHelper.updateExperience({
        finish: dateFinish
      });

      AmplitudeService.track('Experience End Date Submit')
      document.location = '#/experiencia-adicionar-outra';
    }
  }



  return (
    <>
      <Header step={ 7 } total={ 8 } title="Adicionar experiência" previous="#/experiencia-entrada"></Header>
      <FormYearMonth
        lastAnswer={ `${months[new Date(experience.start).getMonth()]} de ${new Date(experience?.start).getFullYear()}` }
        question="Agora, <strong>quando foi a saída</strong>?"
        interactions={interactions}
        onSubmit={ setLeaveYear }
      />
    </>);
}
